import { inject, Injectable } from '@angular/core';
import { Patient } from '@pixacare/domain';
import { PagedResponse, PaginationQuery } from '@pixacare/shared';
import { PagedCollection } from '@shared/models/pagination/paged-collection';
import { Observable } from 'rxjs';
import { PatientHttpService } from 'src/app/services/http/patient.http.service';
import { getNextPagedCollection } from 'src/app/shared/models/helpers/pagination-helper';
import { patientPaginationContext } from 'src/app/shared/models/pagination/pagination-context.config';
import { Pagination } from 'src/app/shared/pagination';

@Injectable({
  providedIn: 'root',
})
export class PatientPaginationService extends Pagination<Patient> {
  private readonly patientService = inject(PatientHttpService);

  getNextData(clientCode: string, { query }: { query: PaginationQuery }): Observable<PagedResponse<Patient>> {
    return this.patientService.getPatients(clientCode, { query });
  }

  getNextCollection({
    currentCollection,
    nextCollection,
    reset,
  }: {
    currentCollection: PagedCollection<{ [id: number]: Patient }>;
    nextCollection: PagedResponse<Patient>;
    reset: boolean;
  }): PagedCollection<{ [id: number]: Patient }> {
    return getNextPagedCollection(
      { currentCollection, nextCollection },
      {
        reset,
        paginationContext: patientPaginationContext,
        sortPredicate: (entityId1, entityId2, entities) =>
          entities[entityId2].lastActivity?.getTime() - entities[entityId1].lastActivity?.getTime(),
      },
    );
  }
}
